// extracted by mini-css-extract-plugin
export default {"gridContainer":"PortfolioGrid_gridContainer__GgR20"};